// extracted by mini-css-extract-plugin
module.exports = {"reservationItemDetail":"OrderItemDetail-Jtails_reservationItemDetail_ltr0m","reservationList":"OrderItemDetail-Jtails_reservationList_2FdLN"};